<template>
  <div
    class="gap-20px flex"
    :class="{
      'flex-col': layout === 'stacked',
      'items-center': layout === 'inline',
    }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    layout: {
      type: String,
      required: false,
      default: "stacked",
    },
  },
};
</script>
